import { Injectable } from '@angular/core';

import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class EdiTypeService {
    constructor(private dataTask: DataTaskService) {}

    /**
     * @datatask 2264
     * @datataskName edi_type_list
     * @param params EDI type list parameters.
     * @returns Promise containing the available EDI types.
     */
    public getEdiTypesList(params: EdiTypeListParams): Promise<EdiTypeListItem[]> {
        return this.dataTask.Post(2264, params);
    }
}

export interface EdiTypeListParams {}

export interface EdiTypeListItem {
    edi_type_keyno: string | number;
    edi_type_name: string;
}
